
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recipes/lamb",
      function () {
        return require("private-next-pages/recipes/lamb.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recipes/lamb"])
      });
    }
  